// Visual frame around a "live demo" subtree on the landing page. The
// real product controls (TaskCard, TaskLine, UpcomingTasks, HourMeter)
// accept no-op click handlers that suppress all internal navigation, so
// no router sandbox is needed — and React Router v6 actively forbids
// nesting Routers, which rules out a MemoryRouter wrapper here.
//
// Anything wrapped by DemoBoundary should be rendered with handlers
// that don't call navigate(); see the helper callbacks in
// src/pages/Home.jsx.

export const DemoBoundary = ({ children, className, ariaLabel }) => (
  <div
    className={className}
    role="group"
    aria-label={ariaLabel || 'Live product demo'}
  >
    {children}
  </div>
);

export default DemoBoundary;
